var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "td",
    { staticClass: "stage__col stage__col_responsible" },
    [
      _c("Select", {
        attrs: {
          name: `responsible[]`,
          items: _vm.allowedUsers,
          active: _vm.responsibleUserId,
        },
        on: { selectChange: (v) => _vm.$emit("update", v) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }